import script from "./TechnologyAssetsComparisonTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyAssetsComparisonTable.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyAssetsComparisonTable.vue?vue&type=style&index=0&id=9cb37cb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cb37cb2"]])

export default __exports__